"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default() {
  return Promise.resolve(window.Plotly || new Promise(function (resolve, reject) {
    /* eslint-disable prefer-const */
    var timeoutId;
    var element = document.createElement('script');
    element.src = window._dashPlotlyJSURL;
    element.async = true;
    element.onload = function () {
      clearTimeout(timeoutId);
      resolve();
    };
    element.onerror = function (error) {
      clearTimeout(timeoutId);
      reject(error);
    };
    timeoutId = setTimeout(function () {
      element.src = '';
      reject(new Error("plotly.js did not load after 30 seconds"));
    }, 3 * 10 * 1000);
    document.querySelector('body').appendChild(element);
  }));
};